import { render, staticRenderFns } from "./channel-advisor.vue?vue&type=template&id=1f47c22a"
import script from "./channel-advisor.vue?vue&type=script&lang=js"
export * from "./channel-advisor.vue?vue&type=script&lang=js"
import style0 from "./channel-advisor.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports